export { ShopifyGeoSpatialDashboard } from "./Tabs";
